// store/slice/permissionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roleId: null,
  permissions: [],
};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissionsData: (state, action) => {
      state.roleId = action.payload.role_Id;
      state.permissions = action.payload.permissions;
    },
    resetPermissions: (state) => {
      state.roleId = null;
      state.permissions = [];
    },
  },
});

export const { setPermissionsData, resetPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
